module.exports = __webpack_public_path__ + "img/26.2018e5a5.svg";